import React, { useEffect } from 'react';
import '../styles/PaymentInterview.css'
import { Button, DatePicker, Dropdown, Label, Phone } from '@ole/react-library-agents';
import { createEventCalendar, getCalendarAvailableDates, getCalendarAvailableHours } from 'services/appointment/service';
import BannerFamily from 'components/BannerFamily';
import { registerAgenda } from 'services/agenda/service';
import { sendSchedulingConfirmationEmail } from 'services/email/emailService';
import { languageMessages } from 'traductor/PaymentInterview';
import HTMLRenderer from 'components/GlobalHTMLParser';
import { REACT_APP_CALENDAR_EMAIL, REACT_APP_CALENDAR_GUEST_EMAIL } from 'config';

interface PageInterviewProps {
    type?: string;
    language?: string;
    name?:string;
    firstName?: string;
    phone?: string;
    email?: string;
    idApplication?: string;
    clientId?: string;
}

interface HourFormat {
    hourApi: string;
    hourFormat: string;
}

const PageInterview = (
    { type, language, name, firstName, phone, email, idApplication, clientId }: PageInterviewProps
) => {
    const [ availableDates, setAvailableDates ] = React.useState<string[]>([]);
    const [ availableHours, setAvailableHours ] = React.useState<HourFormat[]>([]);
    const [ selectedDate, setSelectedDate ] = React.useState<string>('');
    const [ selectedHour, setSelectedHour ] = React.useState<string>('');
    const [ selectedHourExam, setSelectedHourExam ] = React.useState<string>('');
    const [ selectedDateExam, setSelectedDateExam ] = React.useState<string>('');
    const [ phoneValue, setPhoneValue ] = React.useState<string>(phone || '');
    const [ haveAgenda, setHaveAgenda ] = React.useState<boolean>(false);

    useEffect(() => {
        if (phone) {
            setPhoneValue(phone);
        }
    }, [phone]);

    useEffect(() => {
        const buildCurrentDate = () => {
            const today = new Date();
            const day = today.getDate().toString().padStart(2, '0');
            const month = (today.getMonth() + 1).toString().padStart(2, '0');
            return `${day}/${month}`;
        };

        const buildTomorrowDate = (): string => {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            
            const day = String(tomorrow.getDate()).padStart(2, '0');
            const month = String(tomorrow.getMonth() + 1).padStart(2, '0'); // Meses base 0
        
            return `${day}/${month}`;
        };

        const fetchAvailableDates = async () => {
            try {
                const response = await getCalendarAvailableDates();
                const today = buildCurrentDate();
                const tomorrow = buildTomorrowDate();
                if (!response.available_dates || response.available_dates.length === 0) {
                    console.warn('No available dates found');
                    return;
                }
                response.available_dates = response.available_dates.filter((date: string) => {
                    return date !== today && date !== tomorrow;
                });
                response.available_dates.sort((a: string, b: string) => {
                    const [dayA, monthA] = a.split('/').map(Number);
                    const [dayB, monthB] = b.split('/').map(Number);
                    if (monthA !== monthB) {
                        return monthA - monthB;
                    }
                    return dayA - dayB;
                });
                setAvailableDates(response.available_dates);
            } catch (error) {
                console.error('Error fetching available dates:', error);
            }
        };

        fetchAvailableDates();
    }
    , []);

    const handleDateChange = async (date: string) => {
        setSelectedDate(date);
        try {
            const day = date.split('/')[0];
            const month = date.split('/')[1];
            const year = (new Date()).getFullYear().toString();
            const formattedDate = `${year}-${month}-${day}`;
            const response = await getCalendarAvailableHours(formattedDate);
            const hours = response.available_hours || [];
            if (hours.length === 0) {
                console.warn('No available hours found for the selected date');
                setAvailableHours([]);
                return;
            }
            // concatenar date con hour y pasar a Date
            const dateWithHours:HourFormat[] = hours.map((hour: string) => {
                const hourTmp = hour.replace('AM', '').replace('PM', '').trim().split(':');
                const hourInt = parseInt(hourTmp[0]);
                const hourAfterInt = hourInt;
                const hourAfter = hourAfterInt < 10 ? `0${hourAfterInt}` : hourAfterInt.toString();
                const minute = hourTmp[1];
                //convertir a new Date
                const dataHourStr = `${formattedDate}T${hourAfter}:${minute}:00Z`;
                const dateHour = new Date(`${dataHourStr}`);
                //console.log('dateHour', dateHour);
                return {
                    hourApi: hour,
                    hourFormat: dateHour.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                }
            });
            //console.log('dateWithHours', dateWithHours);
            setAvailableHours(dateWithHours);
        }
        catch (error) {
            console.error('Error fetching available hours:', error);
        }
    };

    const handleSaveAppoinment = async() => {
        if (type?.includes('v')) {
            const dateTmp = selectedDate.split('/');
            const day = dateTmp[0];
            const month = dateTmp[1];
            const year = new Date().getFullYear().toString();
            const formattedDate = `${year}-${month}-${day}`;
            const hourTmp = selectedHour.replace('AM', '').replace('PM', '').trim().split(':');
            const hour = hourTmp[0];
            const hourInt = parseInt(hour);
            const hourAfterInt = hourInt + 1;
            const hourAfter = hourAfterInt < 10 ? `0${hourAfterInt}` : hourAfterInt.toString();
            const minute = hourTmp[1];
            const formattedHour1 = `${hour}:${minute}:00Z`;
            const formattedHour2 = `${hourAfter}:${minute}:00Z`;
            const formattedDateHour1 = `${formattedDate}T${formattedHour1}`;
            const formattedDateHour2 = `${formattedDate}T${formattedHour2}`;
            const guests = REACT_APP_CALENDAR_GUEST_EMAIL.split(',').map(email => email.trim());
            await createEventCalendar({
                date_start: `${formattedDateHour1}`,
                date_end: `${formattedDateHour2}`,
                summary: `${languageMessages(language || 'es', 'subject')} (${name})`,
                description: `${languageMessages(language || 'es', 'greeting')}<b>${name}</b>,\n${email}\n${phone}\n\n ${languageMessages(language || 'es', 'bodyHTML')}`,
                calendar_id: REACT_APP_CALENDAR_EMAIL,
                guests: [
                    ...guests,
                    email || ''
                ],
            });

            await registerAgenda({
                id_application: idApplication || '',
                origin: clientId || 'adminseg',
                date_agenda: formattedDate,
                hour_agenda: formattedHour1,
                type: 'video'
            });

            // Envío best-effort del correo de confirmación: un fallo aquí no debe romper el agendamiento
            if (email) {
                try {
                    await sendSchedulingConfirmationEmail({
                        firstName: firstName || name || '',
                        name: name,
                        email,
                        subject: languageMessages(language || 'es', 'subject')
                    });
                } catch (error) {
                    console.error('Error sending scheduling confirmation email:', error);
                }
            }
        }

        if (type?.includes('m') && selectedDateExam && selectedHourExam) {
            const dateExamTmp = selectedDateExam.split('-');
            const dayExam = dateExamTmp[0];
            const monthExam = dateExamTmp[1];
            const yearExam = dateExamTmp[2] || new Date().getFullYear().toString();
            const formattedDateExam = `${yearExam}-${monthExam}-${dayExam}`;
            const hourExamTmp = selectedHourExam.replace('AM', '').replace('PM', '').trim();
            const hourExam = hourExamTmp === '1' ? '08:00:00Z' : hourExamTmp === '2' ? '14:00:00Z' : '20:00:00Z';

            await registerAgenda({
                id_application: idApplication || '',
                origin: clientId || 'adminseg',
                date_agenda: formattedDateExam,
                hour_agenda: hourExam,
                type: 'medical_exam'
            });
        }

        setHaveAgenda(true);
    }

    return (
        <div className='page__interview'>
            <div className='header'>
                <img src='logo_ole_transparent.svg' alt='Logo' className='logo' />
            </div>
            <div className='body'>
                <div className='content'>
                    <div className='title'><HTMLRenderer html={languageMessages(language || 'es', 'titlePage')}/></div>
                    <div className='subtitle'>{languageMessages(language || 'es', 'subtitlePage')} <b>{email}</b></div>
                        {
                        !haveAgenda && <div className='form'>
                            {
                                type?.includes('v') && <div className='form__video'>
                                    <div className='form__title'>{languageMessages(language || 'es', 'scheduleInterview')}</div>
                                    <div className='form__content'>
                                        <div className='row'>
                                            <Label text={languageMessages(language || 'es', 'whatsappLabel')} isRequired />
                                            <Phone
                                                value={phoneValue}
                                                language={language || 'es'}
                                                onChange={(value: string) => setPhoneValue(value)}
                                                required={true}
                                            />
                                        </div>
                                        <div className='row'>
                                            <Label text={languageMessages(language || 'es', 'whenContact')} isRequired />
                                            <Dropdown
                                                label=''
                                                placeholder={languageMessages(language || 'es', 'selectPlaceholder')}
                                                style={{ width: '100%' }}
                                                onChange={handleDateChange}
                                                options={availableDates.map((date) => ({ value: date, label: date }))}
                                                value={selectedDate}
                                            />
                                        </div>
                                        <div className='row'>
                                            <Label text={languageMessages(language || 'es', 'timeContact')} isRequired />
                                            <Dropdown
                                                label=''
                                                placeholder={languageMessages(language || 'es', 'selectPlaceholder')}
                                                style={{ width: '100%' }}
                                                options={availableHours.map((hour:HourFormat) => ({ value: hour.hourApi, label: hour.hourFormat }))}
                                                onChange={(hour:string) => setSelectedHour(hour)}
                                                value={selectedHour}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                type?.includes('m') && <div className='form__exam'>
                                    <div className='form__title'>{languageMessages(language || 'es', 'scheduleExam')}</div>
                                    <div className='form__subtitle'>{languageMessages(language || 'es', 'scheduleExamRecommendation')}</div>
                                    <div className='form__content'>
                                        <div className='row'>
                                            <Label text={languageMessages(language || 'es', 'availableDate')} isRequired />
                                            <DatePicker
                                                format="dd/mm/yyyy"
                                                onChange={(date:string) => setSelectedDateExam(date)}
                                                selectedDate={selectedDateExam}
                                                id='datePicker'
                                                language={language || 'es'}
                                                required={false}
                                            />
                                        </div>
                                        <div className='row'>
                                            <Label text={languageMessages(language || 'es', 'availableTime')} isRequired />
                                            <Dropdown
                                                label=''
                                                placeholder={languageMessages(language || 'es', 'selectPlaceholder')}
                                                style={{ width: '100%' }}
                                                options={[
                                                    { value: '1', label: languageMessages(language || 'es', 'morning') },
                                                    { value: '2', label: languageMessages(language || 'es', 'afternoon') },
                                                    { value: '3', label: languageMessages(language || 'es', 'evening') }
                                                ]}
                                                onChange={(hour:string) => setSelectedHourExam(hour)}
                                                value={selectedHourExam}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            <div>
                                <Button label={languageMessages(language || 'es', 'scheduleButton')} action size='large' fontWeight='bold' onClick={handleSaveAppoinment} />
                            </div>
                        </div>
                    }
                </div>
                <div className='banner'>
                    <BannerFamily />
                </div>
            </div>
        </div>
    );
};
export default PageInterview;
